import React, { useState, useEffect } from "react";
import {
  Button,
  Form,
  Input,
  Modal,
  Spin,
  Select,
  message,
  Radio,
  Upload,
} from "antd";
import { UploadOutlined, DownloadOutlined } from "@ant-design/icons";
import { postLifterDispatch, getDoData } from "../../Services/Services";

const AddLifterDispatch = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [doList, setDoList] = useState([]);
  const [assignData, setAssignData] = useState({});
  const [remQty, setRemQty] = useState(0);
  const [isMultiple, setIsMultiple] = useState(false);
  const [mode, setMode] = useState("single");
  const [form] = Form.useForm();

  useEffect(() => {
    const multiple = localStorage.getItem("is_multiple") === "true";
    setIsMultiple(multiple);
    Get_Do_Details();
  }, []);

  const Get_Do_Details = async () => {
    const response = await getDoData({
      com_name: localStorage.getItem("com_name"),
    });
    if (response) setDoList(response);
  };

  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);

  const Get_Do_Id = async (do_id) => {
    const rem_qty = doList.find((do_lis) => do_lis.do_id === do_id);
    setRemQty(Number(rem_qty?.rem_qty || 0));
    setAssignData(rem_qty);
    form.setFieldsValue({
      freight_rate: rem_qty?.freight_rate || "",
    });
  };

  const downloadTemplate = () => {
    const link = document.createElement("a");
    link.href = "/demo_excel_file.xlsx";
    link.download = "Sample Excel.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const onFinish = async (values) => {
    console.log("Form values:", values);
    if (mode === "multiple") {
      const fileList = values.excel_upload; // ✅ Correct
      console.log("Uploaded file list:", fileList);

      if (!fileList || fileList.length === 0) {
        message.warning("Please upload an Excel file!");
        return;
      }

      const formData = new FormData();
      formData.append("lifter_id", localStorage.getItem("user_id"));
      formData.append("client_id", assignData.client_id);
      formData.append("do_id", values.do_id);
      formData.append("shortage_rate", assignData.shortage_rate);
      formData.append("freight_rate", assignData.freight_rate || "0");
      formData.append("com_name", localStorage.getItem("com_name"));
      formData.append("multiple", "true");
      formData.append("excel_file", fileList[0].originFileObj);
      setLoading(true);
      const response = await postLifterDispatch(formData);
      setLoading(false);

      if (response) {
        let dispatchData;
        if (response.data && Array.isArray(response.data)) {
          dispatchData = response.data;
        } else if (Array.isArray(response)) {
          dispatchData = response;
        } else {
          message.error("Unexpected response format");
          return;
        }
        props.setdispatchList(dispatchData);
        props.setdispatchData(dispatchData);

        form.resetFields();
        setAssignData({});
        setIsModalOpen(false);
      } else {
        message.error("Dispatch Upload Failed");
      }
      return;
    }

    // Single dispatch
    setLoading(true);
    const payload = {
      ...values,
      lifter_id: localStorage.getItem("user_id"),
      client_id: assignData.client_id,
      shortage_rate: assignData.shortage_rate,
      com_name: localStorage.getItem("com_name"),
    };

    const response = await postLifterDispatch(payload);
    setLoading(false);

    if (response) {
      const sortedArray = [...response].sort((a, b) => b.id - a.id);
      props.setdispatchList(sortedArray);
      props.setdispatchData(sortedArray);
      message.success("Dispatch Entry Successful");
      form.resetFields();
      setIsModalOpen(false);
    } else {
      message.warning("Dispatch Entry Not Successful");
    }
  };

  return (
    <>
      <Modal open={loading} footer={null} closable={false} width={400}>
        <div className="flex flex-col items-center justify-center">
          <img
            src="transduniyalogo.png"
            alt="img"
            width={200}
            style={{ margin: "10px" }}
          />
          <Spin />
          <h2>Dispatch Creating......</h2>
        </div>
      </Modal>

      <Button
        onClick={showModal}
        style={{
          margin: "10px",
          backgroundColor: "black",
          color: "white",
          fontWeight: "600",
          borderRadius: "6px",
        }}
      >
        Add New Dispatch
      </Button>

      <Modal open={isModalOpen} onCancel={handleCancel} footer={null}>
        <Form form={form} onFinish={onFinish} layout="vertical">
          {isMultiple && (
            <Form.Item>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: "10px",
                }}
              >
                <Radio.Group
                  value={mode}
                  onChange={(e) => setMode(e.target.value)}
                  style={{
                    display: "flex",
                    gap: "40px",
                    fontWeight: "500",
                    fontSize: "15px",
                  }}
                >
                  <Radio value="single">Single</Radio>
                  <Radio value="multiple">Multiple</Radio>
                </Radio.Group>
              </div>
            </Form.Item>
          )}

          {/* ✅ If mode is multiple → show only DO + Upload */}
          {mode === "multiple" && isMultiple ? (
            <>
              <Form.Item
                name="do_id"
                rules={[
                  { required: true, message: "Please select the DO ID!" },
                ]}
                label={<b>Select DO No</b>}
                style={{ padding: "2px", margin: "2px" }}
              >
                <Select
                  showSearch
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  onChange={Get_Do_Id}
                >
                  {doList.map((do_i) => (
                    <Select.Option key={do_i.do_id} value={do_i.do_id}>
                      {do_i.do_no}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label={<b>Upload Excel File</b>}
                style={{ marginBottom: 0 }}
              >
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <Form.Item
                    name="excel_upload"
                    valuePropName="fileList"
                    getValueFromEvent={(e) => e?.fileList}
                    noStyle
                  >
                    <Upload
                      name="file"
                      maxCount={1}
                      accept=".xls,.xlsx"
                      beforeUpload={() => false}
                      onChange={(info) => console.log(info)}
                    >
                      <Button icon={<UploadOutlined />}>Click to Upload</Button>
                    </Upload>
                  </Form.Item>

                  <Button
                    icon={<DownloadOutlined />}
                    onClick={downloadTemplate}
                  >
                    Download Sample
                  </Button>
                </div>
              </Form.Item>
            </>
          ) : (
            // ✅ Single Form Fields (Same as original)
            <div className="grid grid-cols-1 sm:grid-cols-2 sm:gap-2 m-auto px-5 sm:w-[70%] md:w-[100%]">
              <Form.Item
                name="do_id"
                rules={[
                  { required: true, message: "Please select the DO ID!" },
                ]}
                label={<b>Select DO No</b>}
              >
                <Select
                  showSearch
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  onChange={Get_Do_Id}
                >
                  {doList.map((do_i) => (
                    <Select.Option key={do_i.do_id} value={do_i.do_id}>
                      {do_i.do_no}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="truck_owner_name"
                label={<b>Truck Owner Name</b>}
              >
                <Input placeholder="Truck Owner Name" size="middle" />
              </Form.Item>

              <Form.Item name="pan_no" label={<b>PAN No</b>}>
                <Input
                  placeholder="PAN No"
                  size="middle"
                  minLength={10}
                  maxLength={10}
                />
              </Form.Item>

              <Form.Item
                name="vehicle_no"
                rules={[
                  { required: true, message: "Please Enter Vehicle No!" },
                ]}
                label={<b>Vehicle No</b>}
              >
                <Input placeholder="Vehicle No" size="middle" maxLength={10} />
              </Form.Item>

              <Form.Item
                rules={[
                  {
                    required: true,
                    message: "Please Enter Dispatch Quantity!",
                  },
                ]}
                name="dispatch_quantity"
                label={<b>Dispatch Quantity</b>}
              >
                <Input
                  placeholder="Dispatch Quantity"
                  type="number"
                  size="middle"
                />
              </Form.Item>

              <Form.Item
                rules={[
                  { required: true, message: "Please Enter Freight Rate!" },
                ]}
                name="freight_rate"
                label={<b>Freight Rate</b>}
              >
                <Input
                  placeholder="Freight Rate"
                  type="number"
                  size="middle"
                  disabled
                  style={{ fontWeight: "600", color: "black" }}
                />
              </Form.Item>

              <Form.Item
                rules={[
                  { required: true, message: "Please Enter Advance Amount!" },
                ]}
                name="advance"
                label={<b>Advance</b>}
              >
                <Input placeholder="Advance" type="number" size="middle" />
              </Form.Item>

              <Form.Item
                rules={[
                  { required: true, message: "Please Enter Dispatch Date!" },
                ]}
                name="date"
                label={<b>Dispatch Date</b>}
              >
                <Input type="date" size="middle" />
              </Form.Item>
            </div>
          )}

          <Form.Item className="text-center mt-4" style={{ textAlign: "center" }}>
            <Button
              htmlType="submit"
              style={{
                color: "white",
                backgroundColor: "black",
                fontSize: "medium",
                borderRadius: "6px",
              }}
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default AddLifterDispatch;
